
{
  "fr": {
    "configuratorCustomThemeList": {
    }
  }
}
